(ns manage.ad-variant.creation.ad-builder.queries
  (:require [cljs-bean.core :refer [->clj]]
            [common.queries :refer [invalidate-queries]]
            [common.queries.http :as qhttp]
            [re-frame.core :as rf]))

(defn patch-ad-builders [{:keys [adset-id]}]
  #js {:mutationKey #js ["patch-ad-builders" adset-id]
       :mutationFn (fn [payload]
                     (qhttp/patch (qhttp/render :api/adset-ad-builders {:adset-id adset-id})
                                  {:body payload}))
       :onMutate (fn []
                   (rf/dispatch [:loader/open]))
       :onSettled (fn []
                    (rf/dispatch [:loader/close]))
       :onSuccess (fn []
                    (invalidate-queries {:queryKey ["adset" adset-id]})
                    (invalidate-queries {:queryKey ["ad-builders-upgrade-hints" adset-id]})
                    (rf/dispatch [:response-handler/handle-response
                                  {:entity-name "ad-builders"
                                   :type :success
                                   :message "Successfully updated ad builders"}]))
       :onError (fn [error]
                  (rf/dispatch [:response-handler/handle-response
                                {:entity-name "ad-builders"
                                 :type :error
                                 :message "Failed to update ad builders"
                                 :response (->clj (:data error))}]))})

(defn put-ad-formats [{:keys [adset-id]}]
  #js {:mutationKey #js ["put-ad-formats" adset-id]
       :mutationFn (fn [payload]
                     (qhttp/put (qhttp/render :api/adset-ad-formats {:adset-id adset-id})
                                {:body payload}))
       :onMutate (fn []
                   (rf/dispatch [:loader/open]))
       :onSettled (fn []
                    (rf/dispatch [:loader/close]))
       :onSuccess (fn []
                    (invalidate-queries {:queryKey ["adset" adset-id]})
                    (invalidate-queries {:queryKey ["ad-builders-upgrade-hints" adset-id]})
                    (rf/dispatch [:response-handler/handle-response
                                  {:entity-name "ad-builders"
                                   :type :success
                                   :message "Successfully updated ad builders"}]))
       :onError (fn [error]
                  (rf/dispatch [:response-handler/handle-response
                                {:entity-name "ad-builders"
                                 :type :error
                                 :message "Failed to update ad builders"
                                 :response (->clj (:data error))}]))})
